var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 25.0609 12.4214 26.0783 13.1716 26.8284C13.9217 27.5786 14.9391 28 16 28C17.0609 28 18.0783 27.5786 18.8284 26.8284C19.5786 26.0783 20 25.0609 20 24",
    fill: "url(#paint0_linear_2259_17997)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0018 13C7.0018 10.6131 7.95001 8.32387 9.63784 6.63604C11.3257 4.94821 13.6148 4 16.0018 4C18.3887 4 20.6779 4.94821 22.3658 6.63604C24.0536 8.32387 25.0018 10.6131 25.0018 13C25.0018 17.4775 26.0393 21.075 26.8643 22.5C26.9519 22.6518 26.9981 22.8239 26.9983 22.9991C26.9984 23.1744 26.9525 23.3466 26.8652 23.4985C26.7778 23.6504 26.6521 23.7767 26.5006 23.8647C26.349 23.9527 26.177 23.9994 26.0018 24H6.0018C5.82677 23.9989 5.65509 23.952 5.50391 23.8638C5.35272 23.7756 5.22734 23.6492 5.14028 23.4974C5.05323 23.3456 5.00755 23.1735 5.00781 22.9985C5.00808 22.8235 5.05428 22.6516 5.1418 22.5C5.96555 21.075 7.0018 17.4763 7.0018 13Z",
    stroke: "url(#paint1_linear_2259_17997)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2259_17997",
    x1: 12,
    y1: 24,
    x2: 20.2395,
    y2: 27.4235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#369D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28814D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2259_17997",
    x1: 5.00781,
    y1: 4,
    x2: 30.2497,
    y2: 9.7659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#369D9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28814D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a68564053ea7a4c676a817a39429ddc7.svg";
export { ForwardRef as ReactComponent };